"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var t = require("./_commonjsHelpers-f10b257f.js"),
  e = t.createCommonjsModule(function (t) {
    function e(o) {
      return t.exports = e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      }, t.exports.__esModule = !0, t.exports["default"] = t.exports, e(o);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  }),
  o = t.getDefaultExportFromCjs(e),
  r = t.createCommonjsModule(function (t) {
    var o = e["default"];
    t.exports = function (t, e) {
      if ("object" !== o(t) || null === t) return t;
      var r = t[Symbol.toPrimitive];
      if (void 0 !== r) {
        var u = r.call(t, e || "default");
        if ("object" !== o(u)) return u;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  }),
  u = t.createCommonjsModule(function (t) {
    var o = e["default"];
    t.exports = function (t) {
      var e = r(t, "string");
      return "symbol" === o(e) ? e : String(e);
    }, t.exports.__esModule = !0, t.exports["default"] = t.exports;
  });
exports._typeof = o, exports._typeof_1 = e, exports.toPropertyKey = u;